import React, { useState, useCallback } from 'react';

// import { sendShareQuoteEmail } from '../../api/draftOrders';
import { getShareUrl, parseEmails } from '../../utils/utils';
import { trackKlaviyoEvent, pushDataLayerEvent } from '../../../utils/utils';
import { addLeadScore, LEAD_SCORE_WEIGHTS } from '../../utils/leadScoring';

import { FiLink, FiCheck, FiMail } from "react-icons/fi";
// import { BsSend } from "react-icons/bs";



export default function ModalShareQuote({ title, orderId, token, quoteName, onClose }) {
  const [emailInput, setEmailInput] = useState('');
  const [copied, setCopied] = useState(false);
  const [openedInMail, setOpenedInMail] = useState(false);

  // const [sending, setSending] = useState(false);
  // const [sendError, setSendError] = useState(null);
  // const [sendSuccess, setSendSuccess] = useState(false);

  const shareUrl = getShareUrl(orderId, token, quoteName);

  const handleCopy = useCallback(async () => {
    try {
      await navigator.clipboard.writeText(shareUrl);
      setCopied(true);
      setTimeout(() => setCopied(false), 1800);
    } catch {
      // fallback: select and suggest copy
      const input = document.getElementById('share-quote-url');
      if (input) {
        input.select();
        input.setSelectionRange(0, 99999);
      }
    }
    const scoreDelta = LEAD_SCORE_WEIGHTS.shareLinkCopied;
    const leadScore = addLeadScore(orderId, scoreDelta, 'share_link_copied');
    pushDataLayerEvent('quote_portal_copy_link', { order_id: orderId, lead_score: leadScore, lead_score_delta: scoreDelta });
    trackKlaviyoEvent('Quote Portal Share Link Copied', {
      DraftOrderId: orderId,
      QuoteID: quoteName || undefined,
      LeadScore: leadScore,
      LeadScoreDelta: scoreDelta,
    });
  }, [shareUrl]);

  const handleOpenInMail = useCallback(() => {
    setOpenedInMail(true);
    setTimeout(() => setOpenedInMail(false), 2500);
    // const quoteName = quoteName || shareUrl.split('?quote_name=')[1].replace('%23', '#');
    // const quoteName = quoteName || getQuoteName();
    // console.log('quoteName', quoteName);
    const emails = parseEmails(emailInput);
    const to = emails.length ? emails.join(',') : '';
    const subject = encodeURIComponent('Quote link');
    // const body = encodeURIComponent(
    //   `View your WillyGoat Playgrounds quote "${quoteName ? `"#${quoteName}"` : ''}" by clicking this link:\n\n${shareUrl}\n\n\n\nIf you have any questions, please contact us at fun@willygoat.com.`
    // );
    const body = encodeURIComponent(
      `View your WillyGoat Playgrounds quote by clicking this link:\n\n${shareUrl}\n\n\n\nIf you have any questions, please contact us at fun@willygoat.com.`
    );

    const mailto = `mailto:${to}?subject=${subject}&body=${body}`;
    window.location.href = mailto;
    
    const scoreDelta = LEAD_SCORE_WEIGHTS.openedInEmail;
    const leadScore = addLeadScore(orderId, scoreDelta, 'opened_in_email');
    pushDataLayerEvent('quote_portal_open_in_mail', { order_id: orderId, lead_score: leadScore, lead_score_delta: scoreDelta });
    trackKlaviyoEvent('Quote Portal Opened in Email', {
      DraftOrderId: orderId,
      QuoteID: quoteName || undefined,
      LeadScore: leadScore,
      LeadScoreDelta: scoreDelta,
    });
  }, [emailInput, shareUrl]);

  // const handleSendEmail = useCallback(async () => {
  //   const emails = parseEmails(emailInput);
  //   if (!emails.length) {
  //     setSendError('Enter at least one email address.');
  //     return;
  //   }
  //   setSendError(null);
  //   setSending(true);
  //   try {
  //     const { sent } = await sendShareQuoteEmail(orderId, token, emails, shareUrl);
  //     setSendSuccess(true);
  //     setTimeout(() => { 
  //       setSendSuccess(false);
  //       onClose?.();
  //     }, 2000);
  //   } catch (err) {
  //     setSendError(err.message || 'Failed to send email');
  //   } finally {
  //     setSending(false);
  //   }
  // }, [orderId, token, emailInput, shareUrl, onClose]);



  return (
    <>

      <div className='form-group form__input-wrapper'>
        <label className='form-label' htmlFor={`share-quote-url`}>
          <span className='form-label-span' >Quote link (anyone with this link can view and update your quotes and information)</span>
        
          <input
            id="share-quote-url"
            name="share-quote-url"
            className={`form-text form-control form-share-quote-url${copied ? ' form-share-quote-url--copied' : ''}`}
            type="text"
            readOnly
            value={shareUrl}
          />
        </label>
      </div>
      <div className="modal-actions">
        <button
          type="button"
          className={`button button--share button--bordered button--share-quote-url ${copied ? ' button--copied' : ''}`}
          onClick={handleCopy}
        >
          {copied ? <FiCheck /> : <FiLink />} {copied ? 'Copied!' : 'Copy Link'}
        </button>
      </div>


      <div className='form-group form__input-wrapper'>
        <label className='form-label' htmlFor={`share-quote-emails`}>
          <span className='form-label-span' >Email addresses (optional, newline or comma separated)</span>
        
          <textarea className='form-textarea form-share-quote-emails'
            value={emailInput}
            id="share-quote-emails"
            name="share-quote-emails"
            onChange={(e) => setEmailInput(e.target.value)}
            placeholder="colleague@example.com, other@example.com"
          />
          </label>
      </div>

      {/* {sendError && (
        <p style={{ color: 'var(--error-color, #c00)' }}>
          {sendError}
        </p>
      )}
      {sendSuccess && (
        <p style={{ color: 'var(--heading-color, #0a0)' }}>
          Email(s) sent successfully.
        </p>
      )} */}


      <div className="modal-actions">
        <button
          type="button"
          className={`button button--primary button--bordered button--open-in-mail ${openedInMail ? ' button--copied' : ''}`}
          onClick={handleOpenInMail}
        >
          {openedInMail ? <FiCheck /> : <FiMail />} {openedInMail ? 'Opened in email' : 'Open In Email'}
        </button>

        {/* <button
          type="button"
          className={`button button--share button--bordered button-send-email ${sending || sendSuccess ? ' button--sent' : ''}`}
          onClick={handleSendEmail}
          disabled={sending || !parseEmails(emailInput).length}
        >
          <BsSend className="send-icon" /> {sending ? `Sending…` : sendSuccess ? 'Sent!' : 'Send Email'}
        </button> */}
      </div>

      
    </>
  );
}

ModalShareQuote.defaultProps = { title: 'Share Quote', className: 'share-quote-modal' };
